import { useTranslation } from "react-i18next";

import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { DeviceProductCard } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/DeviceProductCard.tsx";
import { getIconForProductCategory } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/ProductCategoryIcon.tsx";
import { SimStatusChip } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/SimStatusChip.tsx";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims.ts";
import { useGetTitle } from "@/hooks/useGetTitle.ts";
import { SimCardDetailSimStatus } from "@/services/model";
import { getFlatNameFromDevice } from "@/utils/deviceUtils";

interface UnverifiedSimTileProps {
  device: ExtendedSimCardDetail;
}

// A device still pending ID verification can't be managed yet.
export const UnverifiedSimTile = ({ device }: UnverifiedSimTileProps) => {
  const { t } = useTranslation("portal");
  const title = useGetTitle(device.alias);
  const flatName = getFlatNameFromDevice(device);
  const icon = getIconForProductCategory(device);

  return (
    <DeviceProductCard
      dataTestid="unverified-sim"
      icon={icon}
      title={title}
      subtitle={flatName}
      // Always "Gesperrt" — backend simStatus still reflects NP/lifecycle and
      // would otherwise read as active/inactive while ID check blocks management.
      chips={<SimStatusChip status={SimCardDetailSimStatus.red} />}
      footer={
        <ProductCardFooterItem
          variant="notification"
          tone="warning"
          title={t("layout.tiles.inactive.beginsAfterID")}
        />
      }
    />
  );
};
